// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ad5c96{--very-subtle: var(--white);--snow: var(--white)}", ""]);
// Exports
exports.locals = {
	"modal": "ad5c96"
};
module.exports = exports;
